import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { AdminCard, AdminPageHeader } from "@/components/admin/admin-shell";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { adminList } from "@/lib/admin";

export const Route = createFileRoute("/_authenticated/admin/audit")({
  component: Page,
});

const fmt = (iso: unknown) =>
  iso ? new Date(String(iso)).toLocaleString("az-AZ") : "—";

function Page() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "admin_audit_log"],
    queryFn: () => adminList("admin_audit_log", "created_at", false),
  });
  const rows = data ?? [];

  return (
    <div>
      <AdminPageHeader
        title="Audit jurnalı"
        description="Adminlərin etdiyi əməliyyatların qeydiyyatı"
      />
      <AdminCard>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tarix</TableHead>
              <TableHead>Admin</TableHead>
              <TableHead>Əməliyyat</TableHead>
              <TableHead>Obyekt</TableHead>
              <TableHead>Təfərrüat</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={String(r["id"])}>
                <TableCell className="whitespace-nowrap">{fmt(r["created_at"])}</TableCell>
                <TableCell className="max-w-40 truncate">{String(r["admin_id"] ?? "—")}</TableCell>
                <TableCell className="font-semibold">{String(r["action"] ?? "—")}</TableCell>
                <TableCell>
                  {String(r["entity"] ?? "—")}
                  <span className="block max-w-40 truncate text-xs text-muted-foreground">
                    {String(r["entity_id"] ?? "")}
                  </span>
                </TableCell>
                <TableCell className="max-w-60 truncate text-xs text-muted-foreground">
                  {JSON.stringify(r["details"] ?? {})}
                </TableCell>
              </TableRow>
            ))}
            {!isLoading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="py-10 text-center text-sm text-muted-foreground">
                  Hələ qeyd yoxdur.
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                <TableCell colSpan={5} className="py-10 text-center">
                  <Loader2 className="mx-auto size-5 animate-spin text-primary" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </AdminCard>
    </div>
  );
}
